/* eslint-disable */
<template>
  <div class="admin_bookings_awaiting_consent">
    <AdminNavigation ref="navigation" indexProps="5" />
    <div class="top-panel">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>Booking Awaiting Consent</h1></div>
        <div class="header-sub-title"></div>
      </div>
    </div>
    <div class="panel">
      <AdminBookingsMenu :key="bookingMenuIndex" :indexProps="bookingMenuIndex" />
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Booking ID" v-model="listParam.BookingID"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Examinee Name" v-model="listParam.ClaimantName"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Client Name" v-model="listParam.ClientName"/>
              <el-input style="max-width: 200px" class="mr-1" @input="search()" clearable placeholder="Contact Name" v-model="listParam.ContactName"/>
            </div>
          </div>
        </div>

        <div class="content-scroll-x">
          <div>
            <div>
              <el-table ref="bookingTable" :default-sort="{prop: 'BookingDateTime', order: 'ascending'}" stripe @sort-change="sortParam" :data="awaitingConsents" tooltip-effect="dark" :header-row-style="{background: '#fde9eb', height: '70px'}" :header-cell-style="{fontWeight: 100}">
                <el-table-column
                    width="100"
                    prop="BookingID"
                    label="ID"
                    sortable="custom"
                    show-overflow-tooltip
                    fixed="left"
                >
                </el-table-column>
                <el-table-column
                    width="200"
                    show-overflow-tooltip
                    prop="BookingDateTime"
                    sortable="custom"
                    label="Booking Date & Time"
                >
                  <template slot-scope="scope">
                    <span>{{
                        formatDate(scope.row.BookingDateTime, "DD/MM/YYYY HH:mm")
                      }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    prop="Client"
                    sortable="custom"
                    label="Client"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.Case && booking.row.Case.Client && decodeURIComponent(booking.row.Case.Client.ClientName)}} - {{decodeURIComponent(booking.row.Case.Client.BranchName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="200"
                    show-overflow-tooltip
                    sortable="custom"
                    prop="ClientContact"
                    label="Client Contact Name">
                  <template slot-scope="booking">
                    <span>{{ booking.row.ClientContact && decodeURIComponent(booking.row.ClientContact.FirstName + ' ' + booking.row.ClientContact.MiddleName + ' ' + booking.row.ClientContact.Surname)}}</span>
                  </template>
                  >
                </el-table-column>
                <el-table-column
                    width="180"
                    show-overflow-tooltip
                    prop="Client"
                    label="Client Phone/Email"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.ClientContact && booking.row.ClientContact.Mobile + ' / ' + booking.row.ClientContact.EmailAddress}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="180"
                    sortable="custom"
                    show-overflow-tooltip
                    label="Examinee Name"
                    prop="ClaimantFullName"
                >
                  <template slot-scope="booking">
                    <span>{{ decodeURIComponent(booking.row.Case.ClaimantFullName)}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                    width="210"
                    sortable="custom"
                    show-overflow-tooltip
                    label="Examinee Phone/Email"
                    prop="ClaimantFullName"
                >
                  <template slot-scope="booking">
                    <span>{{booking.row.Case && (booking.row.Case.ClaimantMobile || booking.row.Case.ClaimantEmail) && booking.row.Case.ClaimantMobile + ' / ' + booking.row.Case.ClaimantEmail}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities"
import AdminNavigation from "@/components/AdminNavigation"
import AdminBookingsMenu from "@/components/AdminBookingsMenu"
import Header from "@/components/Header"
import { debounce } from 'lodash';

export default {
  name: "AdminBookingsAwaitingConsent",
  components: {
    AdminNavigation,
    AdminBookingsMenu,
    Header,
  },
  data() {
    return {
      bookings: [],
      allBookings: [],
      limit: 10,
      pagination: utilities.initPagination(),
      bookingMenuIndex: 3,
      awaitingConsents: [],
      allAwaitingConsents: [],
      totalCount: 0,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'BookingDateTime',
        BookingID: null,
        ascOrDesc: 'ASC',
        ClientName: '',
        ClaimantName: '',
        ContactName: ''
      },
    }
  },
  computed: {},
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    sortParam(v) {
      this.listParam.orderBy = v
      this.selectPage(1)
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },
    isDate(date) {
      return moment(date).isValid()
    },

    openBooking(id) {
      let routeData = this.$router.resolve({ path: '/admin-manage-booking', query: { id: id } })
      window.open(routeData.href, '_blank')
    },

    getCanRingClaimantTitle(booking) {
      var title = booking.redHealthMayContactClaimant ? "Can ring claimant" : "Can not ring claimant"
      return title
    },

    formatDate(dateToFormat, newFormat, currentFormat = "") {
      return utilities.formatDate(dateToFormat, newFormat, currentFormat)
    },

    async loadData() {
      await this.$store.dispatch("loading/setLoadComponent", true)
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      const {bookings, total} = await utilities.getBookingAwaitingConsentNew(obj)
      this.awaitingConsents = _.cloneDeep(bookings)
      console.log(this.awaitingConsents)
      this.totalCount = total
      await this.$store.dispatch("loading/setLoadComponent", false)
    },
  },
  async beforeMount() {
    await this.loadData()
  },
  mounted() {
    $(".pagination").hide()
  },
}
</script>
